import Flickity from 'flickity';

let flickityInstance = null;
let lastIsMobile = null;

export function initShowcase() {
    const scrollUpButton = document.querySelector('.showcase-hero__scroll-up');
    const scrollDownButton = document.querySelector('.showcase-hero__scroll-down');
    const thumbnailsContainer = document.querySelector('.showcase-hero__thumbnails');
    const imgA = document.getElementById('main-showcase-image-a');
    const imgB = document.getElementById('main-showcase-image-b');
    const SCROLL_AMOUNT = 150;
    const TOLERANCE = 5;

    if (!scrollUpButton || !scrollDownButton || !thumbnailsContainer || !imgA || !imgB) return;

    function scrollUp() {
        thumbnailsContainer.scrollBy({ top: -SCROLL_AMOUNT, behavior: 'smooth' });
    }

    function scrollDown() {
        thumbnailsContainer.scrollBy({ top: SCROLL_AMOUNT, behavior: 'smooth' });
    }

    function updateArrows() {
        const { scrollTop, scrollHeight, clientHeight } = thumbnailsContainer;
        const atTop = scrollTop <= TOLERANCE;
        const atBottom = Math.abs(scrollTop + clientHeight - scrollHeight) <= TOLERANCE;
        const scrollable = scrollHeight > clientHeight;

        scrollUpButton.classList.toggle('visible', scrollable && !atTop);
        scrollDownButton.classList.toggle('visible', scrollable && !atBottom);
    }

    function getAbsoluteUrl(url) {
        const link = document.createElement('a');
        link.href = url;
        return link.href;
    }

    function updateMainImage(fullImageUrl, altText) {
        const active = imgA.classList.contains('active') ? imgA : imgB;
        const next = active === imgA ? imgB : imgA;

        const currentUrl = getAbsoluteUrl(active.src);
        const newUrl = getAbsoluteUrl(fullImageUrl);
        if (currentUrl === newUrl) return;

        const tempImg = new Image();
        tempImg.src = fullImageUrl;

        tempImg.onload = () => {
            next.src = fullImageUrl;
            next.alt = altText;
            next.classList.add('active');
            active.classList.remove('active');
        };
    }

    function waitForImagesToLoad(images, callback) {
        let loaded = 0;
        const total = images.length;
        if (total === 0) {
            callback();
            return;
        }

        images.forEach(img => {
            if (img.complete) {
                loaded++;
            } else {
                img.addEventListener('load', onLoad);
                img.addEventListener('error', onLoad);
            }
        });

        function onLoad() {
            loaded++;
            if (loaded === total) callback();
        }

        setTimeout(callback, 500);
    }

    scrollUpButton.addEventListener('click', scrollUp);
    scrollDownButton.addEventListener('click', scrollDown);
    thumbnailsContainer.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    const observer = new MutationObserver(updateArrows);
    observer.observe(thumbnailsContainer, { childList: true, subtree: true });

    const thumbnails = thumbnailsContainer.querySelectorAll('.showcase-hero__thumbnail');
    thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {
            const fullImageUrl = thumbnail.getAttribute('src');
            const altText = thumbnail.getAttribute('alt') || '';
            updateMainImage(fullImageUrl, altText);
        });

        thumbnail.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                thumbnail.click();
            }
        });
    });

    const images = thumbnailsContainer.querySelectorAll('img');
    waitForImagesToLoad(images, updateArrows);
}

export function hasShowcase() {
    return document.querySelector('.showcase') !== null;
}

function destroyFlickity() {
    if (flickityInstance && typeof flickityInstance.destroy === 'function') {
        flickityInstance.destroy();
        flickityInstance = null;
    }
}

function initOrDestroyShowcaseCarousel() {
    const carouselContainer = document.querySelector('.showcase-hero__mobile-carousel');
    if (!carouselContainer) {
        destroyFlickity();
        lastIsMobile = null;
        return;
    }

    const isMobile = window.innerWidth <= 1024;

    if (lastIsMobile === isMobile) return;
    lastIsMobile = isMobile;

    if (flickityInstance) destroyFlickity();

    if (!isMobile) return;

    const images = carouselContainer.querySelectorAll('.showcase-hero__carousel-image');
    if (images.length <= 1) {
        images[0]?.classList.add('single-image');
        return;
    }

    const leftArrow = carouselContainer.querySelector('.showcase-hero__scroll-left');
    const rightArrow = carouselContainer.querySelector('.showcase-hero__scroll-right');

    flickityInstance = new Flickity(carouselContainer, {
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: false,
        imagesLoaded: true,
        cellSelector: '.showcase-hero__carousel-image'
    });

    function updateArrowVisibility() {
        const atStart = flickityInstance.selectedIndex === 0;
        const atEnd = flickityInstance.selectedIndex === flickityInstance.slides.length - 1;

        leftArrow.classList.toggle('visible', !atStart);
        rightArrow.classList.toggle('visible', !atEnd);
    }

    leftArrow?.addEventListener('click', () => flickityInstance.previous());
    rightArrow?.addEventListener('click', () => flickityInstance.next());

    flickityInstance.on('select', updateArrowVisibility);
    flickityInstance.on('ready', updateArrowVisibility);
}

export function initShowcaseCarousel() {
    initOrDestroyShowcaseCarousel();
    window.addEventListener('resize', initOrDestroyShowcaseCarousel);
}
